import config from '@/api/config'

export default{
	install(Vue){
		Vue.prototype.messages = function(val,type){
			this.$message({
			  message:val,
			  type
			});
		},
		Vue.prototype.loadings = function(status){
			let loading = '';
			if(status){
				loading = this.$loading({
				  lock: true,
				  text: 'Loading',
				  spinner: 'el-icon-loading',
				  background: 'rgba(0, 0, 0, 0.7)'
				});
			}else{
			loading.close();
			}
		}
	},
}

/**
 * 为图片地址加上域名
 */
export function appendImg(path) {
	if(path.length <= 0)
		return path;
    if(path.indexOf('http') !== -1){
        return path;
    }else{
        return config.img_url + path;
    }
}


/**
 * 判断是否为空
 */
export function isEmpty(value) {
    switch (typeof value) {
    case 'undefined':
        return true
    case 'string':
        if (value.replace(/(^[ \t\n\r]*)|([ \t\n\r]*$)/g, '').length == 0) return true
        break
    case 'boolean':
        if (!value) return true
        break
    case 'number':
        if (value === 0 || isNaN(value)) return true
        break
    case 'object':
        if (value === null || value.length === 0) return true
        for (const i in value) {
            return false
        }
        return true
    }
    return false
}


/**
 * 计算两个日期 共占总天数
 * 
 */
export function getDaysSum(begin_time, end_time) {
    //计算寄养天数
    const days = (Math.abs(new Date(begin_time).getTime() - new Date(end_time).getTime()) / (1000 * 60 * 60 * 24)) + 1;
				
    return parseInt(days < 1 ? 1 : days);
}

let timer, flag;
/**
 * 节流原理：在一定时间内，只能触发一次
 * 
 * @param {Function} func 要执行的回调函数 
 * @param {Number} wait 延时的时间
 * @param {Boolean} immediate 是否立即执行
 * @return null
 */
export function throttle(func, wait = 500, immediate = false) {
	if (immediate) {
		if (!flag) {
			flag = true;
			// 如果是立即执行，则在wait毫秒内开始时执行
			typeof func === 'function' && func();
			timer = setTimeout(() => {
				flag = false;
			}, wait);
		}
	} else {
		if (!flag) {
			flag = true
			// 如果是非立即执行，则在wait毫秒内的结束处执行
			timer = setTimeout(() => {
				flag = false
				typeof func === 'function' && func();
			}, wait);
		}
		
	}
};
/**
 * 防抖原理：一定时间内，只有最后一次操作，再过wait毫秒后才执行函数
 *
 * @param {Function} func 要执行的回调函数
 * @param {Number} wait 延时的时间
 * @param {Boolean} immediate 是否立即执行
 * @return null
 */
let timeout = null
export function debounce(func, wait = 500, immediate = false) {
    return (args)=>{
        // 清除定时器
        if (timeout !== null) clearTimeout(timeout)
        // 立即执行，此类情况一般用不到
        if (immediate) {
            const callNow = !timeout
            timeout = setTimeout(() => {
                timeout = null
            }, wait)
            if (callNow) typeof func === 'function' && func(args)
        } else {
            // 设置定时器，当最后一次操作后，timeout不会再被清除，所以在延时wait毫秒后执行func回调方法
            timeout = setTimeout(() => {
                typeof func === 'function' && func(args)
            }, wait)
        }
    }
}
// /**
//  * 节流
//  * 
//  */
// let timer = null;
// export function throttle(func, delay) {
//     return function() {
//       const context = this;
//       const args = arguments;
//       if (!timer) {
//         timer = setTimeout(function() {
//           func.apply(context, args);
//           timer = null;
//         }, delay);
//       }
//     };
// }


/**
 * 根据a的参数->将b赋值给a
 */
export function assignParams(a, b) {
    // 获取a对象与b对象共同存在的属性名，并遍历它们
    Object.entries(b).forEach(([key, value]) => {
        if (a.hasOwnProperty(key)) {
            a[key] = value;
        }
    });
    return a;
}

/**
 * 根据时间戳返回年龄
 */
export function timestampToAge(timestamp) {
    if ( timestamp == 0) {
        return '-'
    }
    const now = new Date();
    const targetDate = new Date(timestamp * 1000); // 时间戳单位为秒，JS 中为毫秒，所以需要乘以 1000 转换为毫秒
    const yearsDiff = now.getFullYear() - targetDate.getFullYear();
    const monthsDiff = now.getMonth() - targetDate.getMonth();
    const totalMonths = yearsDiff * 12 + monthsDiff;
    const years = Math.floor(totalMonths / 12);
    const months = totalMonths % 12;
    const petAge = `${( years ? years + '岁' : '')}${months ? months + '个月' : ''}` 
    return petAge || '1个月'
}

/**
 * 重置当前组件的所有参数为初始值
 */
export function resetInsertData(that, keys = [], isKeep = false){
    const options  = that.$options.data.call(that)
    const filteredData =  Object.keys(options).filter(key => (isKeep ? keys.includes(key) : !keys.includes(key))).reduce((obj, key) => {
        obj[key] = options[key];
        return obj;
      }, {});
    Object.assign(that.$data, filteredData);
}



// WEBPACK FOOTER //
// ./src/common/js/util.js